import { mobiClient } from '@/services/axiosConfig'

export const sendCooperationInfo = async (req: FormData): Promise<any | undefined> => {
  try {
    const res = await mobiClient.post('/vendor', req, {
      headers: {
        'Content-type': 'multipart/form-data',
        Accept: 'application/json',
        type: 'formData'
      }
    })
    return { status: res.status, data: res.data }
  } catch (e: any) {
    console.error('Error sending cooperation info:', e)
    return { status: e.response?.status, data: e.response?.data }
  }
}
